<template>
    <nav class="space-y-2 md:bg-[#E8FAE8] md:rounded-xl md:py-4 md:px-5" aria-label="Sidebar">
        <a @click="changeTab('account')" aria-current="page"
            :class="['flex items-center gap-x-4 text-xl font-medium px-6 py-3 rounded-[12px]', tabName == 'account' ? 'bg-[#A4EBA2]' : 'hover:bg-[#BBF0B9]']">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path
                    d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" />
            </svg>
            <span class="truncate">Profile</span>
        </a>
        <!-- this tab is temporarily hidden. -->
        <!-- <a @click="changeTab('newsletters')"
            :class="['flex items-center gap-x-4 text-xl font-medium px-6 py-3 rounded-[12px]', tabName == 'newsletters' ? 'bg-[#A4EBA2]' : 'hover:bg-[#BBF0B9]']">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path
                    d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" />
            </svg>
            <span class="truncate">Newsletter</span>
        </a> -->
        <a @click="changeTab('support')"
            :class="['flex items-center gap-x-4 text-xl font-medium px-6 py-3 rounded-[12px]', tabName == 'support' ? 'bg-[#A4EBA2]' : 'hover:bg-[#BBF0B9]']">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path
                    d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
            </svg>
            <span class="truncate">Support</span>
        </a>
    </nav>
</template>

<script>


import TabIcon from './TabIcon.vue';

export default {

    props: {
        modelValue: String
    },
    components: { TabIcon },
    methods: {
        changeTab(tab) {
            this.tabName = tab
        }
    },
    computed: {
        tabName: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    }
}
</script>